import { createSlice } from "@reduxjs/toolkit";
import {
  TradeInvestment,
  hashTradeType,
} from "../../component/Methods";

const initialState = {
  lots: [],
  loading: false,
  error: null,
};

function getUid() {
  const characters = "0123456789abcdef";
  const length = 32;
  let uniqueIdentifier = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueIdentifier += characters[randomIndex];
  }
  return uniqueIdentifier;
}

const lotsSlice = createSlice({
  name: "lots",
  initialState,
  reducers: {
    clearLotsError: (state) => {
      state.error = null;
    },
    setLotsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLots: (state, action) => {
      const { lots, trades } = action.payload;
      let processedLots = lots?.length > 0 ? lots : state?.lots;

      //ADDING TODAYS TRADES TO LOTS
      let todaysTrades = "";
      let completedShares = 0;
      let completedSharesPrice = 0;
      const currentDate = new Date();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const year = currentDate.getFullYear();
      const formattedDate = `${month}/${day}/${year}`;
      const startOfDay = new Date(formattedDate).getTime();
      const endOfDay = startOfDay + 86400000 - 60;

      if (trades) {
        todaysTrades = trades?.filter((row) => {
          const lastOrder = row?.orders?.slice(-1)[0];
          return lastOrder?.date > startOfDay && lastOrder?.date < endOfDay;
        });

        todaysTrades = todaysTrades.filter((row) => {
          if (row?.manuals.length > 0 || row.hasOwnProperty("fills")) {
            return true;
          }
        });

        todaysTrades?.map((trade) => {
          if (trade?.manuals.length > 0) {
            const lastManual = trade?.manuals.slice(-1)[0];
            completedShares = lastManual.shareCount;
            completedSharesPrice = lastManual.sharePrice;
          } else if (
            trade?.manuals.length == 0 &&
            trade.hasOwnProperty("fills")
          ) {
            completedShares = trade.fills?.shareCount;
            completedSharesPrice = trade.fills?.sharePrice;
          }

          if (Array.isArray(trade?.orders)) {
            const lastOrder = trade.orders.slice(-1)[0];
            if (lastOrder.ticker.investment === TradeInvestment.Equity) {
              //EQUITY TRADES

              let fundkey = Object.keys(lastOrder?.distribution)[0];
              let strategy = lastOrder.hasOwnProperty("strategy")
                ? lastOrder.strategy
                : undefined;
              if (
                hashTradeType(lastOrder?.action, lastOrder?.position) == 1 ||
                hashTradeType(lastOrder?.action, lastOrder?.position) == 2
              )
                completedShares = completedShares * -1;
              if (completedShares != 0) {
                let topush = {
                  cost: 0,
                  currency: "USD",
                  custodian: getUid(),
                  date: Date.now(),
                  fund: fundkey,
                  investment: TradeInvestment.Equity,
                  position: lastOrder?.position,
                  shareCount: completedShares,
                  sharePrice: completedSharesPrice,
                  ticker: {
                    currency: 7,
                    exchange: 3,
                    investment: TradeInvestment.Equity,
                    symbol: lastOrder?.ticker.symbol,
                    tickerId: getUid(),
                  },
                  value: -15345.680000000002,
                  lotId: getUid(),
                };
                if (
                  hashTradeType(lastOrder?.action, lastOrder?.position) == 0 ||
                  hashTradeType(lastOrder?.action, lastOrder?.position) == 1
                )
                  topush.todaybuysell = true;
                if (
                  hashTradeType(lastOrder?.action, lastOrder?.position) == 2 ||
                  hashTradeType(lastOrder?.action, lastOrder?.position) == 3
                )
                  topush.todayshortcover = true;
                if (strategy) {
                  topush.strategy = strategy;
                }

                //  lots.push(topush);
              }
            }
          }
        });
      }

      state.lots = processedLots;
    },
    addLot: (state, action) => {
      state.lots.push(action.payload);
    },
    updateLot: (state, action) => {
      const { lotId, updates } = action.payload;
      const index = state.lots.findIndex(lot => lot.lotId === lotId);
      if (index !== -1) {
        state.lots[index] = { ...state.lots[index], ...updates };
      }
    },
    removeLot: (state, action) => {
      const lotId = action.payload;
      state.lots = state.lots.filter(lot => lot.lotId !== lotId);
    },
    clearLots: (state) => {
      state.lots = [];
    },
  },
});

export const { 
  clearLotsError, 
  setLotsLoading,
  setLots,
  addLot,
  updateLot,
  removeLot,
  clearLots
} = lotsSlice.actions;
export default lotsSlice.reducer;

// Selectors
export const selectLots = (state) => state.lots.lots;
export const selectLotsLoading = (state) => state.lots.loading;
export const selectLotsError = (state) => state.lots.error;
